export default "__VITE_ASSET__DUV2VzU3__"